export default __webpack_public_path__ + "static/Plots0002-1013f4cc5e4acfc087a06fa832f9583c.jpg";